// Presentation only. Keep the previous pair until a complete, current response is ready.
export function validSuggestions(value) {
  return Array.isArray(value) && value.length === 2 && value.every(item =>
    item && typeof item.label === 'string' && item.label.trim() && item.label.length <= 16 &&
    typeof item.text === 'string' && item.text.trim() && item.text.length <= 40) &&
    value[0].text !== value[1].text;
}

export async function refreshWelcomeSuggestions(page) {
  const owner = page._api;
  const epoch = page._conversationEpoch || 0;
  const request = page._welcomeSuggestionRequest = (page._welcomeSuggestionRequest || 0) + 1;
  try {
    const result = await owner.post('page/suggestions', {});
    if (!page._alive || page._visible === false || owner !== page._api ||
      epoch !== (page._conversationEpoch || 0) || request !== page._welcomeSuggestionRequest ||
      page.session || page.pendingRequest || page.turns.length || !validSuggestions(result && result.suggestions)) return false;
    page.pageState.copy = { ...page.pageState.copy, suggestions: result.suggestions };
    return true;
  } catch (_) {
    // Suggestions are optional; transport retains account/closed-page isolation.
    return false;
  }
}
